import type { QueryFunctionContext } from '@tanstack/react-query';
import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { transcriptionSettingsKeys } from './transcriptionSettingsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof transcriptionSettingsKeys.organization>>;

export const createFetchTranscriptionSettingsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) => {
    if (!organizationId) {
      throw new Error('Organization is required for transcription settings');
    }
    return call(
      () => cancelOnSignal(OrganizationsService.getOrganizationTranscriptionSettings({ organizationId }), signal),
      {
        dontRedirectOnError: true,
      },
    );
  };
